import InvestorInvestManage from './investor-invest-manage';

export default InvestorInvestManage;
